import styled, { css } from 'styled-components/macro';

export const TwoRowTextWrapper = styled.div<{ margin?: string; display?: string }>`
  display: ${({ display }) => (display ? display : 'block')};
  ${({ margin }) => margin && `margin: ${margin};`}
`;

export const Title = styled.h5<{
  titleColor?: string;
  bold?: boolean;
  cursor?: string;
  textDecoration?: string;
  titleFontFamily?: string;
}>`
  overflow: hidden;

  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ titleColor, theme }) => (titleColor ? titleColor : theme.colors.black_100)};
  ${({ cursor }) => cursor && `cursor: ${cursor};`}
  ${({ textDecoration }) => textDecoration && `text-decoration: ${textDecoration};`}
  ${({ bold }) =>
    bold &&
    css`
      font-weight: ${({ theme }) => theme.fontWeight.medium};
      font-family: ${({ theme }) => theme.fontFamily.semiBold};
      line-height: ${({ theme }) => theme.lineHeight.one_2};
      letter-spacing: ${({ theme }) => theme.letterSpacing.md};
    `}
  ${({ titleFontFamily }) => titleFontFamily && `font-family: ${titleFontFamily};`}
`;

export const Subtitle = styled.h6<{ color?: string; fontWeight?: string; fontSize?: string }>`
  overflow: hidden;

  color: ${({ color, theme }) => (color ? color : theme.colors.black_80)};

  font-weight: ${({ fontWeight, theme }) => (fontWeight ? fontWeight : theme.fontWeight.regular)};
  font-size: ${({ fontSize, theme }) => (fontSize ? fontSize : theme.fontSize.xs)};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  line-height: ${({ theme }) => theme.lineHeight.one_3};
  white-space: nowrap;
  text-overflow: ellipsis;
`;
